import { Formik } from 'formik';
import { Link } from 'react-router-dom';

import AuthForm from './AuthForm';
import AuthInput from './AuthInput';
import AuthOr from './AuthOr';
import AuthSub from './AuthSub';
import AuthSubmit from './AuthSubmit';
import { usernameOnlySchema } from './schemas/username-only.schema';

import { AuthRoutes } from '@/interfaces/auth/AuthRoutes.enum';

type PropTypes = {
	handleSubmit: (username: string) => Promise<void>;
	loading: boolean;
};
export default function ResendConfirmationCodeForm({
	handleSubmit,
	loading,
}: PropTypes) {
	const initialValues = {
		username: '',
	};
	return (
		<Formik
			initialValues={initialValues}
			validationSchema={usernameOnlySchema}
			onSubmit={({ username }) => handleSubmit(username)}
		>
			{({ errors, touched }) => (
				<AuthForm>
					<AuthInput
						name="username"
						label="Username"
						type="email"
						placeholder="user@example.com"
						error={!!errors.username}
						touched={touched.username}
						data-test="resend-confirmation-code-username"
					/>
					<AuthSubmit
						isLoading={loading}
						data-test="resend-confirmation-code-submit"
						className="bg-purpleBrand-500 hover:bg-purpleBrand-600 active:bg-purpleBrand-900"
					/>
					<AuthOr />
					<AuthSub>
						<p>
							Already have your code?{' '}
							<Link
								className="font-medium text-purpleBrand-500"
								to={AuthRoutes.ConfirmUser}
								data-test="link-confirm-user"
							>
								Click here
							</Link>
						</p>
					</AuthSub>
				</AuthForm>
			)}
		</Formik>
	);
}
